import L from 'leaflet';
import 'leaflet-layerindex';
import RTree from 'rtree';

window.RTree = RTree; // leaflet layerindex expects RTree to be a thing;

function noop() {
    //
}

function fetchJSON(url, callback, context) {
    var request = new XMLHttpRequest();
    request.open('GET', url, true);
    request.onload = function() {
        var data = JSON.parse(request.responseText);
        callback.call(context, data);
    };
    request.send();
}

function getBoundsWithPadding(map, padding) {
    var bounds = map.getPixelBounds(),
        sw = map.unproject(bounds.getBottomLeft().add([-padding, padding])),
        ne = map.unproject(bounds.getTopRight().add([padding, -padding]));

    return new L.LatLngBounds(sw, ne);
}

function SortedList(options) {
    this.options = options;
}

SortedList.prototype = new Array();

SortedList.prototype.push = function(value) {
    for (var i = Math.min(this.options.n, this.length); i >= 0; --i) {
        var key = this.options.key(value);
        
        if (i === 0) {
            this.unshift(value);
            break;
        }

        if (this.options.key(this[i - 1]) > key) {
            if (i < this.options.n)
                this.splice(i, 0, value);

            break;
        }
    }

    if (this.length > this.options.n)
        this.pop();

    return this.length;
}

L.LayerGroup.include({
    updateLayers: function(layers) {
        var _layers = {};

        for (var i = 0; i < layers.length; ++i)
            _layers[this.getLayerId(layers[i])] = layers[i];

        var toRemove = [];

        for (var id in this._layers) {
            if (!(id in _layers))
                toRemove.push(this._layers[id]);
        }

        toRemove.forEach(this.removeLayer, this);

        for (var id in _layers) {
            if (!(id in this._layers))
                this.addLayer(_layers[id]);
        }

        return this;
    }
});

L.NearestLayerMixin = L.GeoJSON.extend({
    includes: L.LayerIndexMixin,

    options: {
        url: null,
        padding: 30, // in pixels
        initialRadius: 0.004,
        maximumRadius: 3
    },

    initialize: function (geojson, options) {
        L.Util.setOptions(this, options);

        this._layers = {};

        this._visible = L.layerGroup([]);

        this._coverage = [];

        if (geojson) {
            this.addData(geojson);
        }
    },

    getLayerId: function(layer) {
        return layer.feature.properties.id;
    },

    addLayer: function (layer) {
        var id = this.getLayerId(layer);

        if (id === undefined)
            throw Error('Cannot index layer; Layer id is undefined');

        if (id in this._layers)
            return this;

        this._layers[id] = layer;
        this.indexLayer(layer);
        
        if (this._map
            && !this._visible.hasLayer(layer)
            && this._layerInView(layer)) {
            this._visible.addLayer(layer);
        }        

        return this;
    },

    onAdd: function (map) {
        this._visible.addTo(map);
        
        map.on('move', this._redraw, this);
        this._redraw();
        
        if (this.options.url) {
            map.on('moveend', this._fetch, this);
            this._fetch(this._redraw, this);
        }
    },

    _getBounds: function() {
        return getBoundsWithPadding(this._map, this.options.padding);
    },

    _redraw: function() {
        this._visible.updateLayers(this.search(this._getBounds()));
    },

    _layerInView: function(layer) {
        return this._layerBounds(layer).intersects(this._getBounds());
    },

    _fetch: function() {
        var bounds = this._getBounds();

        if (this._fetched(bounds))
            return;
        
        this._fetchBounds(bounds, noop);
    },

    _fetchBounds: function(bounds, callback, context) {
        fetchJSON(this.options.url + '?bbox=' + bounds.toBBoxString(),
            function(results) {
                this._coverage.push(bounds);
                this.addData(results);
                callback.call(context, results);
            }, this);
    },

    _fetched: function(bounds) {
        for (var i = 0; i < this._coverage.length; ++i)
            if (this._coverage[i].contains(bounds))
                return true;

        return false;
    },

    _searchBuffer: function(latlng, radius, callback, context) {
        var bounds = L.latLngBounds(
            [latlng.lat - radius, latlng.lng - radius],
            [latlng.lat + radius,  latlng.lng + radius]);

        var search = L.Util.bind(function() {
            var results = this.searchBuffer(latlng, radius);
            callback.call(context, results);
        }, this);
        
        if (this._fetched(bounds)) {
            search();
        } else {
            this._fetchBounds(bounds, search);
        }
    },

    nearest: function(latlng, n, callback, filter, context) {
        var maximumRadius = this.options.maximumRadius;

        var search = L.Util.bind(function(radius) {
            this._searchBuffer(latlng, radius, function(results) {
                if (results.length < n && radius < maximumRadius)
                    return search(radius * 8);
                
                var best = new SortedList({
                    n: n,
                    key: function(feature) {
                        return -1 * feature.getLatLng().distanceTo(latlng);
                    }
                });

                if (filter)
                    results = results.filter(function(result) {
                        return filter.call(context, result);
                    });

                results.forEach(best.push.bind(best));

                callback.call(context, best);
            });
        }, this);

        search(this.options.initialRadius);
    },

    toJSON: function() {
        return {rtree: this._rtree};
    }
});
